import { render, staticRenderFns } from "./CreateOrderOther.vue?vue&type=template&id=02ca8434&"
import script from "./CreateOrderOther.vue?vue&type=script&lang=js&"
export * from "./CreateOrderOther.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderOther.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports